/**
 * Snoeff Itch Quiz — funnel logic + Klaviyo tracking.
 * No dependencies. Works with the sections/quiz-funnel.liquid markup.
 */
(function () {
  'use strict';

  var QUIZ_ID = window.SnoeffQuizConfig && window.SnoeffQuizConfig.quizId ? window.SnoeffQuizConfig.quizId : 'itch-quiz-v1';
  var root = document.querySelector('[data-quiz-root]');
  if (!root) return;

  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-screen]'));
  // Progress bar and back button live outside data-quiz-root (top bar / back-bar), so both are queried globally.
  var progressBar = document.querySelector('[data-quiz-progress-bar]');
  var backButton = document.querySelector('[data-quiz-back]');

  // Linear step order. Interstitials pick their a/b/variant version at runtime.
  var STEP_ORDER = ['entry', 'q1', 'int1', 'q2', 'int2', 'q3', 'int3', 'complete', 'offer'];

  var state = {
    stepIndex: 0,
    answers: {
      q1: [],
      q2: [],
      q3: null
    }
  };

  function screenFor(name) {
    return root.querySelector('[data-screen="' + name + '"]');
  }

  function showScreen(name) {
    screens.forEach(function (el) {
      el.hidden = el.getAttribute('data-screen') !== name;
    });
    updateProgress(name);
    updateBackButton(name);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateProgress(name) {
    if (!progressBar) return;
    var idx = STEP_ORDER.indexOf(name);
    if (idx === -1) idx = 0;
    var pct = Math.round((idx / (STEP_ORDER.length - 1)) * 100);
    progressBar.style.width = pct + '%';
  }

  function updateBackButton(name) {
    if (!backButton) return;
    backButton.hidden = name === 'entry' || name === 'complete' || name === 'offer';
  }

  function currentStepName() {
    return STEP_ORDER[state.stepIndex];
  }

  function goToStep(index) {
    state.stepIndex = Math.max(0, Math.min(STEP_ORDER.length - 1, index));
    var name = currentStepName();

    // Branch interstitials based on answers already given.
    if (name === 'int1') {
      showBranch('int1', state.answers.q1.indexOf('none') !== -1 ? 'b' : 'a');
    } else if (name === 'int2') {
      var bothNone = state.answers.q1.indexOf('none') !== -1 && state.answers.q2.indexOf('none') !== -1;
      showBranch('int2', bothNone ? 'b' : 'a');
    } else if (name === 'int3') {
      showBranch('int3', state.answers.q3 === 'yes' ? 'yes' : 'no');
    }

    showScreen(name);
  }

  function showBranch(step, variant) {
    var el = screenFor(step);
    if (!el) return;
    var variants = el.querySelectorAll('[data-variant]');
    variants.forEach(function (v) {
      v.hidden = v.getAttribute('data-variant') !== variant;
    });
  }

  function nextStep() {
    goToStep(state.stepIndex + 1);
  }

  function prevStep() {
    goToStep(state.stepIndex - 1);
  }

  // ---- Klaviyo ----

  function klaviyoReady(callback) {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      callback(window.klaviyo);
      return;
    }
    // klaviyo.js loads async; retry briefly rather than dropping the event.
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        clearInterval(interval);
        callback(window.klaviyo);
      } else if (attempts > 20) {
        clearInterval(interval);
      }
    }, 250);
  }

  function trackEvent(eventName, properties) {
    klaviyoReady(function (klaviyo) {
      try {
        klaviyo.push(['track', eventName, properties || {}]);
      } catch (e) {
        // Klaviyo not available (blocked, offline, etc). Fail silently, never block the quiz.
      }
    });
  }

  function identifyProfile(properties) {
    klaviyoReady(function (klaviyo) {
      try {
        klaviyo.push(['identify', properties || {}]);
      } catch (e) {
        // no-op
      }
    });
  }

  // ---- Answer handling ----

  function toggleMultiSelect(groupEl, value, isNoneOption) {
    var answers = groupEl.getAttribute('data-question') === 'q1' ? state.answers.q1 : state.answers.q2;
    var idx = answers.indexOf(value);

    if (isNoneOption) {
      answers.length = 0;
      answers.push(value);
    } else {
      var noneIdx = answers.indexOf('none');
      if (noneIdx !== -1) answers.splice(noneIdx, 1);
      if (idx === -1) {
        answers.push(value);
      } else {
        answers.splice(idx, 1);
      }
    }
    return answers;
  }

  function renderSelectedState(groupEl, answers) {
    var options = groupEl.querySelectorAll('[data-option]');
    options.forEach(function (opt) {
      var val = opt.getAttribute('data-option');
      opt.setAttribute('aria-pressed', answers.indexOf(val) !== -1 ? 'true' : 'false');
    });
  }

  function updateContinueState(screenName) {
    var el = screenFor(screenName);
    if (!el) return;
    var continueBtn = el.querySelector('[data-quiz-continue]');
    if (!continueBtn) return;
    var hasAnswer =
      screenName === 'q1' ? state.answers.q1.length > 0 :
      screenName === 'q2' ? state.answers.q2.length > 0 :
      screenName === 'q3' ? !!state.answers.q3 :
      true;
    continueBtn.disabled = !hasAnswer;
  }

  // ---- Wire up events ----

  if (backButton) {
    backButton.addEventListener('click', function () {
      prevStep();
    });
  }

  root.addEventListener('click', function (e) {
    var optionEl = e.target.closest('[data-option]');
    if (optionEl) {
      var groupEl = optionEl.closest('[data-question]');
      var question = groupEl.getAttribute('data-question');
      var value = optionEl.getAttribute('data-option');
      var isNone = optionEl.hasAttribute('data-none-option');

      if (question === 'q3') {
        // Single-select.
        state.answers.q3 = value;
        var q3options = groupEl.querySelectorAll('[data-option]');
        q3options.forEach(function (o) {
          o.setAttribute('aria-pressed', o.getAttribute('data-option') === value ? 'true' : 'false');
        });
      } else {
        var answers = toggleMultiSelect(groupEl, value, isNone);
        renderSelectedState(groupEl, answers);
      }

      updateContinueState(question);

      trackEvent('Quiz Answer Selected', {
        quiz_id: QUIZ_ID,
        question: question,
        answer: value
      });
      return;
    }

    var continueEl = e.target.closest('[data-quiz-continue]');
    if (continueEl && !continueEl.disabled) {
      var fromScreen = currentStepName();
      if (fromScreen === 'q1') {
        identifyProfile({
          quiz_id_last: QUIZ_ID,
          quiz_q1_symptoms: state.answers.q1
        });
      }
      if (fromScreen === 'q2') {
        identifyProfile({
          quiz_id_last: QUIZ_ID,
          quiz_q2_other_issues: state.answers.q2
        });
      }
      if (fromScreen === 'q3') {
        identifyProfile({
          quiz_id_last: QUIZ_ID,
          quiz_q3_other_supplements: state.answers.q3
        });
      }
      nextStep();
      return;
    }

    var startEl = e.target.closest('[data-quiz-start]');
    if (startEl) {
      trackEvent('Quiz Started', { quiz_id: QUIZ_ID });
      nextStep();
      return;
    }

    var revealEl = e.target.closest('[data-quiz-reveal]');
    if (revealEl) {
      trackEvent('Quiz Completed', {
        quiz_id: QUIZ_ID,
        q1_symptoms: state.answers.q1,
        q2_other_issues: state.answers.q2,
        q3_other_supplements: state.answers.q3
      });
      identifyProfile({
        quiz_id_last: QUIZ_ID,
        quiz_completed: true,
        quiz_q1_symptoms: state.answers.q1,
        quiz_q2_other_issues: state.answers.q2,
        quiz_q3_other_supplements: state.answers.q3
      });
      nextStep();
      return;
    }

    var shopEl = e.target.closest('[data-quiz-shop]');
    if (shopEl) {
      trackEvent('Quiz Offer Clicked', { quiz_id: QUIZ_ID });
      // Let the link navigate normally; no preventDefault.
    }
  });

  // Initial state.
  showScreen('entry');
  updateContinueState('q1');
  updateContinueState('q2');
  updateContinueState('q3');
})();